import { useUserStore, usePageStore } from '@/store';
import { mapState as rootMapState } from 'pinia';
import { h, resolveDirective, withDirectives } from 'vue';
import { sendVowEmail } from '@/components/sign-log';
import './title-mask-v2.scss';

//  show logic : 1.  not logged in  2.  Login unverified email
export default {
    i18next: {
        ns: 'md-house'
    },
    computed: {
        ...rootMapState(usePageStore, {
            currencySymbol: store => store.currency.symbol
        }),
        ...rootMapState(useUserStore, {
            user: store => store.user
        }),
        isLogin() {
            return !!this.user;
        }
    },
    render() {
        let rawHTML = this.isLogin
            ? this.$t('md-house.verifyYourEmail')
            : this.currencySymbol + '****';

        let click = resolveDirective('click');
        return withDirectives(
            h('p', {
                class: 'hide-price title-mask-v2',
                innerHTML: rawHTML
            }),
            [
                [
                    click,
                    {
                        selector: '.link',
                        callback: this.isLogin ? this.toVerify : null,
                        modifier: {
                            prevent: true,
                            stop: true
                        }
                    }
                ]
            ]
        );
    },
    methods: {
        toVerify() {
            sendVowEmail({ user: this.user, isResend: true });
        }
    }
};
